import React from 'react'
import styled from 'styled-components'
import { Icon } from '../../../../../atoms/Icon'

const SearchContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.default};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
`

const SearchInputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`

const SearchIconWrapper = styled.div`
  position: absolute;
  left: ${({ theme }) => theme.spacing.small};
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.text.tertiary};
  pointer-events: none;
`

const SearchInput = styled.input`
  width: 100%;
  padding: ${({ theme }) => theme.spacing.small}
    ${({ theme }) => theme.spacing.small} ${({ theme }) => theme.spacing.small}
    36px;
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  color: ${({ theme }) => theme.colors.text.primary};
  background: ${({ theme }) => theme.colors.background.primary};
  transition: all ${({ theme }) => theme.transitions.fast};

  &::placeholder {
    color: ${({ theme }) => theme.colors.text.tertiary};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.primary}20;
  }
`

const ClearButton = styled.button`
  position: absolute;
  right: ${({ theme }) => theme.spacing.small};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.text.tertiary};
  cursor: pointer;
  transition: all ${({ theme }) => theme.transitions.fast};

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
    background: ${({ theme }) => theme.colors.background.tertiary};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }
`

export interface SearchBarTranslations {
  placeholder?: string
  searchAriaLabel?: string
  clearAriaLabel?: string
}

const DEFAULT_TRANSLATIONS: SearchBarTranslations = {
  placeholder: 'Search documents...',
  searchAriaLabel: 'Search documents',
  clearAriaLabel: 'Clear search',
}

interface SearchBarProps {
  value: string
  onChange: (value: string) => void
  translations?: SearchBarTranslations
}

export const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  translations,
}) => {
  const t = { ...DEFAULT_TRANSLATIONS, ...translations }

  const handleClear = () => {
    onChange('')
  }

  return (
    <SearchContainer>
      <SearchInputWrapper>
        <SearchIconWrapper>
          <Icon name="search" size="small" />
        </SearchIconWrapper>
        <SearchInput
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={t.placeholder}
          aria-label={t.searchAriaLabel}
        />
        {value && (
          <ClearButton
            onClick={handleClear}
            type="button"
            aria-label={t.clearAriaLabel}
          >
            <Icon name="x" size="small" />
          </ClearButton>
        )}
      </SearchInputWrapper>
    </SearchContainer>
  )
}
